import { useEffect, useState } from 'react';
import { Typography, Space } from 'antd';
import { useDispatch } from 'react-redux';
import { fetchExcessStockCountInWorkorder } from '../../slices/work-order';

const { Text } = Typography;

const ExcessStockCount = ({ profileId, length, alloyId, temperId }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [totalBundles, setTotalBundles] = useState(0);
  const [totalPieces, setTotalPieces] = useState(0);
  useEffect(() => {
    if (profileId && length && alloyId && temperId) {
      setLoading(true);

      dispatch(
        fetchExcessStockCountInWorkorder({
          profileId,
          length,
          alloyId,
          temperId,
        }),
      )
        .unwrap()
        .then(response => {
          setTotalBundles(response.total_bundles || 0);
          setTotalPieces(response.total_pieces || 0);
        })
        .catch(error => {
          console.error('Error fetching excess stock count:', error);
          setTotalBundles(0);
          setTotalPieces(0);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [profileId, length, alloyId, temperId, dispatch]);

  if (!profileId || !length || !alloyId || !temperId) {
    return null;
  }

  return (
    <div className="spacewrp">
      <label>Excess Stock:</label>
      {loading ? (
        <Space>
          <div>
            Total Bundles: <Text type="success">0</Text>
          </div>

          <div>
            Total Pieces: <Text type="success">0</Text>
          </div>
        </Space>
      ) : (
        <Space>
          <div>
            Total Bundles: <Text type="success">{totalBundles}</Text>
          </div>

          <div>
            Total Pieces: <Text type="success">{totalPieces}</Text>
          </div>
        </Space>
      )}
    </div>
  );
};

export default ExcessStockCount;
